"use client";

import React from "react";
import Image from "next/image";
import Navbar from "@/components/layout/navbar/Navbar";
import Breadcrumb from "@/components/Common/Breadcrumb";
import Button from "@/components/ui/Button";

const Hero: React.FC = () => {

    return (
        <section className="relative w-full sm:min-h-88 bg-[#1B365E] flex flex-col items-center justify-start mb-10">
            <div className="absolute inset-0 z-0">
                <Image
                    src="/assets/methode-hero-bg.svg"
                    alt="Hero Background"
                    fill
                    priority
                    className="object-cover w-full h-full"
                />
                <div className="absolute inset-0 bg-[#1B365E]/55 sm:hidden" aria-hidden="true" />
            </div>

            <div className="relative z-100 w-full">
                <Navbar />
            </div>

            <div className="relative z-10 px-4 xl:px-10 pt-13.75 sm:pt-22 mb-10.75 sm:mb-6.5 w-full mx-auto">
                <Breadcrumb />
                <h1 className="font-red-hat font-normal text-[30px] sm:text-[48px] md:text-[60px] text-white leading-9.25 sm:leading-12.5 md:leading-19.75 tracking-[0.2px] mb-4.75 mx-auto">
                    Notre Méthode
                </h1>
                <p className="text-white text-[14px] sm:text-[20px] leading-5 sm:leading-7.5 font-medium tracking-[0.2px] max-w-169.75 pt-9 sm:pt-0">Des formations sélectionnées avec soin, des mentors experts et des études de cas réelles : notre méthode transforme chaque parcours en compétences directement utiles, du premier échange jusqu&apos;au suivi après la formation.</p>
                <p className="text-white text-[14px] sm:text-[20px] leading-5 sm:leading-7.5 font-medium tracking-[0.2px] mt-3.25">OPCO, OPCA, CPF... Optimisez le financement de votre formation.</p>
                <div className="mt-5.5 flex items-start sm:items-center sm:flex-row flex-col gap-4 sm:gap-8">
                    <Button className="sm:w-fit w-full" onClick={() => window.location.href = "/quiz"}>
                        Se laisser guider
                    </Button>
                    <Button className="sm:w-fit w-full" variant="gradient" onClick={() => window.location.href = "/formations"}>
                        Choisir votre formation
                    </Button>
                </div>
            </div>

            <div className="flex items-center bg-white rounded-[40px] border-b border-[#40BFDE] py-3 px-4 justify-center absolute left-1/2 -translate-x-1/2 -bottom-5">
                <Image src='/assets/small-logo.svg' alt='small-logo' title='small-logo' width={30} height={17} />
            </div>

        </section>
    );
};

export default Hero;


// 